<template>
  <div class="bubbles d-flex flex-column flex-md-row justify-content-center align-items-stretch justify-content-md-around align-items-md-start">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'bubbles'
}
</script>
